import React, { useEffect, useState } from 'react';
import {
  Platform,
  TouchableWithoutFeedback,
  View,
  ViewStyle,
} from 'react-native';

import styles from './lesson-progress-bar.style';
import { PositionIndicator } from './position-indicator/position-indicator.component';
import { useColors } from '../../hooks';
import useOnLayout from '../../hooks/use-on-layout';
import { ProgressBarFragment } from '../progress-bar-fragment/progress-bar-fragment';
interface ProgressBarProps {
  currentIndex?: number;
  totalActivities: number;
  completedActivities: number;
  isIndicatorVisible: boolean;
  containerStyle?: ViewStyle;
}

export function LessonProgressBar({
  currentIndex = 0,
  totalActivities = 1,
  completedActivities = 0,
  isIndicatorVisible = true,
  containerStyle,
}: ProgressBarProps) {
  const [{ width }, onLayout] = useOnLayout();
  const [isProgressLabelVisible, setProgressLabelVisibility] = useState(false);
  const colors = useColors();
  const toggleMobileProgressLabelVisibility = () => {
    if (Platform.OS === 'web') {
      return;
    }
    setProgressLabelVisibility(!isProgressLabelVisible);
  };

  useEffect(() => {
    if (Platform.OS === 'web') {
      return;
    }

    if (!isProgressLabelVisible) {
      return;
    }

    const timeout = setTimeout(() => {
      setProgressLabelVisibility(false);
    }, 2000);

    return () => {
      clearTimeout(timeout);
    };
  }, [isProgressLabelVisible]);

  const mouseEvents = {
    onMouseEnter: () => setProgressLabelVisibility(true),
    onMouseLeave: () => setProgressLabelVisibility(false),
  };

  return (
    <TouchableWithoutFeedback
      onPress={toggleMobileProgressLabelVisibility}
      {...mouseEvents}
      hitSlop={{ top: 20, bottom: 20 }}
    >
      <View onLayout={onLayout} style={[styles.container, containerStyle]}>
        <ProgressBarFragment
          containerStyle={[styles.fragment]}
          index={0}
          progress={(completedActivities / totalActivities) * 100}
          hasIndexAnimationDelay={false}
          animationDurationInMs={500}
          isProgressLabelVisible={isProgressLabelVisible}
        />
        {isIndicatorVisible && totalActivities > 0 && (
          <PositionIndicator
            fragmentIndex={currentIndex}
            fragmentWidth={width / totalActivities}
            innerColor={colors.primary}
            borderColor={colors.background}
            borderWidth={2}
          />
        )}
      </View>
    </TouchableWithoutFeedback>
  );
}
